import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import axios from 'axios';
import VehicleCard from '../components/VehicleCard';
import { FaSearch, FaCar, FaMotorcycle, FaChartLine } from 'react-icons/fa';

const HomePage = () => {
  const [featuredVehicles, setFeaturedVehicles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeaturedVehicles = async () => {
      try {
        const { data } = await axios.get('https://backend.stu89674.webhosting.arden.ac.uk/api/vehicles');
        setFeaturedVehicles(data.slice(0, 6));
        setLoading(false);
      } catch (error) {
        console.error('Error fetching vehicles:', error);
        setLoading(false);
      }
    };

    fetchFeaturedVehicles();
  }, []);

  return (
    <>
      <div className="hero-section text-center">
        <Container>
          <h1 className="display-4 fw-bold mb-4">Find Your Perfect Ride</h1>
          <p className="lead mb-5">Browse thousands of quality second-hand vehicles at unbeatable prices</p>
          <Button variant="primary" size="lg" className="me-2">
            <FaSearch className="me-2" />
            Browse Vehicles
          </Button>
          <Button variant="outline-light" size="lg">
            Sell Your Vehicle
          </Button>
        </Container>
      </div>

      <Container>
        <h2 className="text-center mb-5">Featured Vehicles</h2>
        {loading ? (
          <div className="text-center">Loading...</div>
        ) : (
          <Row>
            {featuredVehicles.map((vehicle) => (
              <Col key={vehicle.vehicle_id} sm={12} md={6} lg={4} className="mb-4">
                <VehicleCard vehicle={vehicle} />
              </Col>
            ))}
          </Row>
        )}

        <Row className="mt-5 mb-5">
          <Col md={4} className="mb-4">
            <Card className="h-100 text-center p-4">
              <FaCar className="feature-icon mx-auto" />
              <h3>Wide Selection</h3>
              <p className="text-muted">
                Choose from thousands of vehicles across all makes and models.
              </p>
            </Card>
          </Col>
          <Col md={4} className="mb-4">
            <Card className="h-100 text-center p-4">
              <FaChartLine className="feature-icon mx-auto" />
              <h3>Competitive Pricing</h3>
              <p className="text-muted">
                Get the best deals with our price comparison tools and market insights.
              </p>
            </Card>
          </Col>
          <Col md={4} className="mb-4">
            <Card className="h-100 text-center p-4">
              <FaMotorcycle className="feature-icon mx-auto" />
              <h3>Easy Process</h3>
              <p className="text-muted">
                From listing to shipping, we make buying and selling vehicles simple.
              </p>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default HomePage;